import React from 'react';
import './LoginView.css'
import Login from '../../components/login/login';

import { Layout } from 'antd';
import HeaderLanding from '../../components/headerLanding/headerLanding';
import FooterLanding from '../../components/footerLanding/footerLanding';
const { Content } = Layout;

const LoginView = () => {

    return <div className='login-view-container'>
        <Layout style={{ width: "100%" }}>
            <HeaderLanding />
            <Content
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#3E246B'
                }}
            >
                <Login />
            </Content>
            <FooterLanding />
        </Layout>
    </div>
}

export default LoginView;